<template>
  <div>
    <SidebarTitle :small="true" icon="" :title="title" class="mt-8" />
    <div v-if="description" class="text-sm text-center">
        {{description}}
    </div>
    <vs-input
      label=""
      color="dark"
      v-model="localValue"
      name="whyDescription"
      class="w-full mb-5"
      autocomplete="off"
    />
  </div>
</template>
<script>
import _ from 'lodash'
import Checkbox from '../Onboarding/Wizard/Checkbox'
import LifeArea from './../Stories/LifeArea'

export default {
  components: {
    Checkbox,
    LifeArea
  },
  props: ['value', 'title', 'description'],
  data () {
    return {
      localValue: null,
      pickerVisible: false
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (value) {
        console.log('value', value)
        this.localValue = value
      }
    },
    localValue: {
      immediate: false,
      handler (localValue) {
        console.log('localValue', localValue)
        this.$emit('input', localValue)
        this.$emit('colorChanged', localValue)
      }
    }
  },
  computed: {
    anyValue () {
      return !this.emptyValue
    },
    emptyValue () {
      return _.isEmpty(this.localValue)
    },
  },
  methods: {
    generateName (color) {
      return `${color}-${this.namespace}`
    }

  }
}
</script>


<style>
</style>
